export default class ContributionPeriod {
    id: number;
    name: string;
    startDate: string;
    endDate: string;
    lastRegistrationDate: string | null;

    constructor(
        name: string,
        startDate: string,
        endDate: string,
        lastRegistrationDate: string | null
    ) {
        this.id = 0;
        this.name = name;
        this.startDate = startDate;
        this.endDate = endDate;
        this.lastRegistrationDate = lastRegistrationDate;

    }
}